import React from "react"
import {
  Col,
  ControlLabel,
  DropdownButton,
  FormControl,
  FormGroup,
  HelpBlock,
  InputGroup,
  MenuItem
} from "react-bootstrap"
import { allFrequencyTypes, getFrequencyText } from "../../../lib/utils"

export default function PeriodSelect({ id, onChange, validationState,
  help, periodType, onChangePeriodType, disabled, ...props }) {

  const getMenuItem = ({ title, value }) =>
    <MenuItem key={ value } onClick={_ => onChangePeriodType ? onChangePeriodType(value) : null}>
      { title }
    </MenuItem>

  return (
    <FormGroup id={ id } validationState={ validationState }>

      <Col componentClass={ ControlLabel } sm={4}>
        Period *
      </Col>

      <Col sm={8}>
        <InputGroup>

          <FormControl id={ id } disabled={ disabled }
            onChange={e => onChange ? onChange(e.target.value) : null}
            {...props}
          />

          <DropdownButton componentClass={ InputGroup.Button }
            id="input-dropdown"
            title={ getFrequencyText(periodType) }
            disabled={ disabled }
          >
            { allFrequencyTypes().map(getMenuItem) }
          </DropdownButton>
        </InputGroup>

        { help && <HelpBlock>{ help }</HelpBlock> }

      </Col>
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/PeriodSelect.js